var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-multi-select", {
    attrs: {
      options: _vm.resources,
      "item-value": "id",
      "return-object": false,
      rules: _vm.rules,
      "allow-group": true,
      multiple: true,
      fetch: _vm.handleFilter,
      disabled: _vm.disabled
    },
    model: {
      value: _vm.vModel,
      callback: function($$v) {
        _vm.vModel = $$v
      },
      expression: "vModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05b4d99b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b4d99b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-mandate-selector/template.html
// module id = null
// module chunks = 